module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingstatus),
      expression: "loadingstatus"
    }],
    staticClass: "pl10px pr10px",
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('div', {
    staticClass: "ibox float-e-margins ibox-content"
  }, [_c('div', {
    staticClass: "form-horizontal pt10px"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label "
  }, [_vm._v("设备ID")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceInfo.displayDeviceid),
      expression: "deviceInfo.displayDeviceid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.deviceInfo.displayDeviceid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deviceInfo, "displayDeviceid", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label focus_color"
  }, [_vm._v("*设备编号")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceInfo.deviceNum),
      expression: "deviceInfo.deviceNum"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.deviceInfo.deviceNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deviceInfo, "deviceNum", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label focus_color"
  }, [_vm._v("*设备类型")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceInfo.obdFlag),
      expression: "deviceInfo.obdFlag"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.deviceInfo.obdFlag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deviceInfo, "obdFlag", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group mb0px"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("开始时间")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    class: {
      'form-group--error': !_vm.validDates
    }
  }, [_c('datepicker', {
    ref: "dateFrom",
    staticClass: "form-control",
    attrs: {
      "options": _vm.localeOption
    },
    model: {
      value: (_vm.queryParam.startTime),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "startTime", $$v)
      },
      expression: "queryParam.startTime"
    }
  }), _vm._v(" "), (!_vm.validDates) ? _c('p', {
    staticClass: "cus_message form-group__message"
  }, [_vm._v("开始时间不得大于结束时间")]) : _vm._e()], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("结束时间")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    class: {
      'form-group--error': !_vm.validDates
    }
  }, [_c('datepicker', {
    ref: "dateTo",
    staticClass: "form-control",
    attrs: {
      "options": _vm.localeOption
    },
    model: {
      value: (_vm.queryParam.endTime),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "endTime", $$v)
      },
      expression: "queryParam.endTime"
    }
  }), _vm._v(" "), (!_vm.validDates) ? _c('p', {
    staticClass: "cus_message form-group__message"
  }, [_vm._v("开始时间不得大于结束时间")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group mb0px"
  }, [(_vm.levv == 1) ? _c('div', {
    key: "user-didi",
    staticClass: "col-sm-12 text-right"
  }, [(_vm.permissionD.indexOf('fileCarList_historyPositionReset') == -1) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.resetQueryParams
    }
  }, [_vm._v("重置")]) : _vm._e(), _vm._v(" "), (_vm.permissionD.indexOf('fileCarList_historyPositionSelect') == -1) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.validDates
    },
    on: {
      "click": _vm.searchInfo
    }
  }, [_vm._v("查询")]) : _vm._e()]) : _c('div', {
    key: "user-rb",
    staticClass: "col-sm-12 text-right"
  }, [(_vm.permission.indexOf('carFileList_historyPositionReset') == -1) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.resetQueryParams
    }
  }, [_vm._v("重置")]) : _vm._e(), _vm._v(" "), (_vm.permission.indexOf('carFileList_historyPositionSelect') == -1) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.validDates
    },
    on: {
      "click": _vm.searchInfo
    }
  }, [_vm._v("查询")]) : _vm._e()])])])]), _vm._v(" "), _c('table', {
    staticClass: "table mb0px table-striped table-bordered"
  }, [_c('thead', [_c('tr', [_vm._l((_vm.theadList), function(thead, index) {
    return _c('th', {
      key: 'theadlist' + index
    }, [_vm._v(_vm._s(thead))])
  }), _vm._v(" "), _c('th')], 2)]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "list-complete",
      "tag": "tbody"
    }
  }, _vm._l((_vm.fileInfoList), function(fileInfo, index) {
    return _c('tr', {
      key: 'fileInfo' + index
    }, [_c('td', [_vm._v(_vm._s(fileInfo.gpsTime))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.createTime))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.latLng))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.address))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.directionName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fileInfo.speed))]), _vm._v(" "), (_vm.levv == 1) ? _c('td', {
      key: "user-didi",
      staticClass: "text-center"
    }, [(_vm.permissionD.indexOf('fileCarList_historyPositionSelectPoint') == -1) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.gotoPosition(fileInfo.latLng, fileInfo.gpsTime)
        }
      }
    }, [_vm._v("查定位点 ")]) : _vm._e(), _vm._v(" "), (_vm.permissionD.indexOf('fileCarList_historyPositionSelectTrace') == -1) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.gotoTrace(fileInfo.gpsTime)
        }
      }
    }, [_vm._v(" 当天轨迹")]) : _vm._e()]) : _c('td', {
      key: "user-rb",
      staticClass: "text-center"
    }, [(_vm.permission.indexOf('carFileList_historyPositionSelectPoint') == -1) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.gotoPosition(fileInfo.latLng, fileInfo.gpsTime)
        }
      }
    }, [_vm._v("查定位点 ")]) : _vm._e(), _vm._v(" "), (_vm.permission.indexOf('carFileList_historyPositionSelectTrace') == -1) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.gotoTrace(fileInfo.gpsTime)
        }
      }
    }, [_vm._v(" 当天轨迹")]) : _vm._e()])])
  }), 0)], 1), _vm._v(" "), (_vm.fileInfoList.length > 0) ? _c('pagination', {
    attrs: {
      "pageInfo": _vm.pageInfo
    },
    on: {
      "getData": _vm.getPageNo
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9fd9b8aa","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/devicedetail/HistoryPosition.vue
// module id = 1608
// module chunks = 0